import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE, formatPercent } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchPricingAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { formatCop } from "../../../../constants/automapAdminDashboardConstants";
import { AnalyticsSummaryGrid } from "../AdminAnalyticsShared";
import { MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminPricingAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchPricingAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <MarketplaceAnalyticsShell
      active="pricing"
      title="Analytics de precios"
      description="Cobertura de precio justo y distribución interna por ciudad/modelo."
      range={range}
      onRangeChange={setRange}
      viewEvent="pricing_analytics_viewed"
    >
      {payload?.disclaimer ? <p className="dealer-state-box muted">{payload.disclaimer}</p> : null}
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && totals ? (
        <>
          <AnalyticsSummaryGrid
            items={[
              { label: "Cobertura fair price", value: formatPercent(totals.fairPriceCoveragePercent) },
              { label: "Con score", value: totals.withFairPriceScore },
              { label: "Bajo mercado", value: totals.belowMarket },
              { label: "Justo", value: totals.fair },
              { label: "Ligeramente alto", value: totals.slightlyHigh },
              { label: "Alto", value: totals.high },
              { label: "Sin datos", value: totals.notEnoughData },
              { label: "Outliers", value: totals.outlierCount },
            ]}
          />
          <section className="dealer-state-box">
            <h3>Precio por ciudad</h3>
            <table className="dealer-inventory-table">
              <thead>
                <tr>
                  <th>Ciudad</th>
                  <th>Listings</th>
                  <th>Promedio</th>
                  <th>Mediana</th>
                </tr>
              </thead>
              <tbody>
                {(payload.byCity || []).map((row) => (
                  <tr key={row.city}>
                    <td>{row.city}</td>
                    <td>{row.count}</td>
                    <td>{formatCop(row.averagePriceCop)}</td>
                    <td>{formatCop(row.medianPriceCop)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
          <section className="dealer-state-box">
            <h3>Por marca/modelo</h3>
            <table className="dealer-inventory-table">
              <thead>
                <tr>
                  <th>Modelo</th>
                  <th>Conteo</th>
                  <th>Promedio</th>
                </tr>
              </thead>
              <tbody>
                {(payload.byMakeModel || []).map((row) => (
                  <tr key={row.makeModel}>
                    <td>{row.makeModel}</td>
                    <td>{row.count}</td>
                    <td>{formatCop(row.averagePriceCop)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
